var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArtboard30(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 45,
    height: 46,
    viewBox: "0 0 45 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        clip-path: url(#clip-Artboard_30);\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #656fb2;\r\n      }\r\n\r\n      .cls-4 {\r\n        filter: url(#Ellipse_306);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_306",
    x: -0.921,
    y: 4.131,
    width: 46.842,
    height: 46.842,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#8082d0",
    floodOpacity: 0.157
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Artboard_30"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 46
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard_30",
    "data-name": "Artboard \\u2013 30",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2481",
    "data-name": "Group 2481",
    transform: "translate(-10534.393 -6659.003)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4",
    transform: "matrix(1, 0, 0, 1, 10534.39, 6659)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_306-2",
    "data-name": "Ellipse 306",
    className: "cls-2",
    cx: 14.421,
    cy: 14.421,
    r: 14.421,
    transform: "translate(8.08 10.13)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_895",
    "data-name": "Path 895",
    className: "cls-3",
    d: "M7946.9,7654.7a2.56,2.56,0,0,0-2.475-2.517c-.172,0-.345,0-.517,0-.067,0-.092-.017-.088-.086,0-.1-.005-.2,0-.3a.567.567,0,0,0-.41-.645h-.241c-.007.03-.037.028-.057.037a.517.517,0,0,0-.322.492c0,.132-.006.265,0,.4,0,.085-.022.107-.106.107-.769,0-1.538,0-2.308,0-.528,0-1.057,0-1.586,0-.082,0-.115-.019-.107-.1s0-.185,0-.277c0-.389-.083-.516-.428-.651h-.216a.6.6,0,0,0-.387.691c.008.076-.005.153,0,.229s-.018.114-.11.113a3.423,3.423,0,0,0-1.085.089,2.552,2.552,0,0,0-1.86,2.086c-.005.025.01.06-.028.072v6.827a.716.716,0,0,1,.07.27,2.585,2.585,0,0,0,2.029,1.93c.047.008.1,0,.14.044h7.777a1.9,1.9,0,0,1,.333-.068,2.563,2.563,0,0,0,1.976-2.453Q7946.916,7657.84,7946.9,7654.7Zm-11.251-.318a1.536,1.536,0,0,1,1.492-1.173q3.6-.008,7.2,0a1.532,1.532,0,0,1,1.534,1.544c0,.136,0,.273,0,.41,0,.082-.019.111-.1.109-.261-.006-.522,0-.783,0h-4.249c-1.666,0-3.331,0-5,0-.121,0-.147-.034-.141-.146A3.682,3.682,0,0,1,7935.653,7654.382Zm10.224,6.51a1.537,1.537,0,0,1-1.571,1.578q-3.561,0-7.125,0a1.531,1.531,0,0,1-1.554-1.3,1.792,1.792,0,0,1-.018-.312q0-2.213,0-4.427c0-.106.022-.14.135-.139q2.5.005,5.006,0t4.995,0c.112,0,.137.031.137.139C7945.876,7657.918,7945.879,7659.4,7945.877,7660.892Z",
    transform: "translate(2616.15 -973.771)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_896",
    "data-name": "Path 896",
    className: "cls-3",
    d: "M7953.307,7682.147a.765.765,0,0,0-.25-.031h-6.052a.509.509,0,0,0-.438.208.516.516,0,0,0,.426.823h3.778c.79,0,1.58,0,2.37,0a.514.514,0,0,0,.166-1Z",
    transform: "translate(2606.835 -998.049)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_897",
    "data-name": "Path 897",
    className: "cls-3",
    d: "M7949.539,7691.669c-.847,0-1.693,0-2.54,0a.537.537,0,0,0-.211.038.519.519,0,0,0-.3.571.5.5,0,0,0,.481.412c.433.006.866,0,1.3,0h0c.425,0,.85,0,1.275,0a.512.512,0,1,0,0-1.023Z",
    transform: "translate(2606.823 -1005.538)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtboard30);
export default __webpack_public_path__ + "static/media/Artboard – 30.2c47220d6c2100415580dbd54c695b7d.svg";
export { ForwardRef as ReactComponent };